import {ISparkSwiperDataFeeder} from "../../../../components/spark-swiper/models/spark-swiper-data-feeder.interface";
import {VideoSlidesService} from "../../video-slides.service";
import {makeObservable, observable, reaction, runInAction} from "mobx";
import {ISparkSwiperController} from "../../../../components/spark-swiper/models/spark-swiper-controller.interface";
import {
    ISparkSwiperSlideController
} from "../../../../components/spark-swiper/models/spark-swiper-slide-controller.interface";
import {VideoSlidesSwiperSlideController} from "./video-slides-swiper-slide.controller";
import {Lazy} from "../../../../../utils/lazy";
import {SparkSwiperController} from "../../../../components/spark-swiper/models/spark-swiper-controller";

export class VideoSlidesSwiper implements ISparkSwiperDataFeeder {
    constructor(private videoSlides: VideoSlidesService) {

        makeObservable(this);

        reaction(() => [this.videoSlides.currentAppliedFilter, this.videoSlides.slidesRenderers],
            () => {
            
                if(this.videoSlides.slidesRenderers.length === 0) {
                    this._currentSlideIndex = 0;
                } else {
                    this._currentSlideIndex = this._getCurrentIndexFromLocalStorage() % this.videoSlides.slidesRenderers.length;
                }


            }, {
                fireImmediately: true
            })
    }

    private _getCurrentIndexFromLocalStorage(): number {

        const currentFilter = this.videoSlides.currentAppliedFilter;
        if (!currentFilter) {
            return 0;
        }

        const storageData = this.videoSlides.getStorageData();

        const now = Date.now();

        if(!storageData.lastIndexPerFilterUpdateTime || now > storageData.lastIndexPerFilterUpdateTime + 24 * 3600 * 1000) {
            // if more than 24 hours passed since last visit we reset the index
            storageData.lastIndexPerFilter = {}
            storageData.lastIndexPerFilterUpdateTime = now;
            this.videoSlides.setStorageData(storageData);
            return 0;
        }

        return this.videoSlides.getStorageData().lastIndexPerFilter[currentFilter.id] ?? 0;
    }


    @observable.ref
    private _currentSlideIndex: number = 0;

    getCurrentItemIndex(): number {
        return this._currentSlideIndex;
    }

    setCurrentItemIndex(value: number) {
        runInAction(() => {
            this._currentSlideIndex = value;
        });

        const filter = this.videoSlides.currentAppliedFilter;
        if (filter) {
            const storageData = this.videoSlides.getStorageData()
            storageData.lastIndexPerFilter[filter.id] = value;
            storageData.lastIndexPerFilterUpdateTime = Date.now()
            this.videoSlides.setStorageData(storageData);
        }

    }

    getMaxItemIndex(): number {
        return Number.MAX_SAFE_INTEGER;
        //return this.getItemsCount() - 1; // if you want the swiper not to be circular anymore uncomment this line and comment the one above
    }


    getItemsCount(): number {
        return this.videoSlides.slidesRenderers.length;
    }

    createSlideController(id: string, swiperController: ISparkSwiperController): ISparkSwiperSlideController {
        return new VideoSlidesSwiperSlideController(id,
                                                    swiperController,
                                                    this.videoSlides);
    }

    private _swiperController = new Lazy<ISparkSwiperController>(() => new SparkSwiperController(this))
    get swiperController(): ISparkSwiperController {
        return this._swiperController.value;
    }
}